"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { useTranslations } from "next-intl"

const TYPES = ["all", "videos", "pictures"] as const
const ORDERS = ["latest", "top", "trending"] as const

interface RedgifsFilterTabsProps {
  type: string
  order: string
  onTypeChange: (value: string) => void
  onOrderChange: (value: string) => void
}

// Redgifs' two real options: videos or pictures (its `type`), and the order (latest, most liked, trending); see lib/booru-sources/redgifs.ts.
export function RedgifsFilterTabs({ type, order, onTypeChange, onOrderChange }: RedgifsFilterTabsProps) {
  const t = useTranslations("redgifsFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[
        { id: "type", label: t("type"), value: type, defaultValue: "all", options: TYPES.map((value) => ({ value, label: t(value) })) },
        { id: "order", label: t("order"), value: order, defaultValue: "latest", options: ORDERS.map((value) => ({ value, label: t(value) })) },
      ]}
      onChange={(id, value) => (id === "type" ? onTypeChange(value) : onOrderChange(value))}
    />
  )
}
